import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { sharedModule } from "src/app/shared/shared.module";
import { AngularTiltModule } from "angular-tilt";
import { SubsidiaryDashboardContractComponent } from './subsidiary-dashboard-contract/subsidiary-dashboard-contract.component';
import { SubsidiaryDashboardContractContractsComponent } from './subsidiary-dashboard-contract/subsidiary-dashboard-contract-contracts/subsidiary-dashboard-contract-contracts.component';
import { SubsidiaryDashboardContractStudentsComponent } from './subsidiary-dashboard-contract/subsidiary-dashboard-contract-students/subsidiary-dashboard-contract-students.component';
import { SubsidiaryDashboardContractStudentEmptyComponent } from './subsidiary-dashboard-contract/subsidiary-dashboard-contract-student-empty/subsidiary-dashboard-contract-student-empty.component';
import { SubsidiaryDashboardImportStudentFilesComponent } from './subsidiary-dashboard-contract/subsidiary-dashboard-import-student-files/subsidiary-dashboard-import-student-files.component';
import { SubsidiaryDashboardContractClassesComponent } from './subsidiary-dashboard-contract/subsidiary-dashboard-contract-classes/subsidiary-dashboard-contract-classes.component';
import { SubsidiaryDashboardContractFinancialComponent } from './subsidiary-dashboard-contract/subsidiary-dashboard-contract-financial/subsidiary-dashboard-contract-financial.component';

// Subsidiary Dashboard Contract
@NgModule({

  declarations: [
    // Contract
    SubsidiaryDashboardContractComponent,
    SubsidiaryDashboardContractContractsComponent,
    SubsidiaryDashboardContractStudentsComponent,
    SubsidiaryDashboardContractStudentEmptyComponent,
    SubsidiaryDashboardImportStudentFilesComponent,
    SubsidiaryDashboardContractClassesComponent,
    SubsidiaryDashboardContractFinancialComponent
  ],
  imports: [sharedModule, FormsModule, AngularTiltModule],
  entryComponents: [
    SubsidiaryDashboardContractStudentEmptyComponent,
    SubsidiaryDashboardImportStudentFilesComponent
  ]
})
export class subsidiaryDashboardModule { }
